<template>
    <div class="row">
        <div class="col-lg-12 col-sm-6 col-12">
            <span class="m-userStores__contactHeader d-lg-none">Dane sklepu</span>
            <div class="m-userStores__formGroup form-group has-effect pt-4 pt-lg-0">
                <the-input
                    required
                    type="text"
                    name="store-name"
                    label="Nazwa sklepu w Panelu"
                    :text="location.full_name"
                    :invalid="invalidEditModeValues.name"
                    invalid-feedback="To pole nie może być puste"
                    :invalid-icon="false"
                    @input="changeName"
                />
                <the-input
                    required
                    type="number"
                    name="store-area"
                    label="Powierzchnia sklepu"
                    :text="location.address.area"
                    :min="0"
                    :invalid="invalidEditModeValues.area"
                    :invalid-feedback="invalidFeedbackArea"
                    :invalid-icon="false"
                    @input="changeArea"
                />
            </div>
        </div>
        <div class="col-lg-12 col-sm-6 col-12">
            <span class="m-userStores__contactHeader">Dane kontaktowe</span>
            <div class="pt-4 pt-lg-3">
                <phone-input
                    required
                    :phone-value="location.address.phone"
                    :placeholder="'Numer telefonu do sklepu'"
                    :invalid-phone="invalidEditModeValues.phone"
                    :invalid-feedback="invalidFeedbackPhone"
                    :invalid-icon="false"
                    @onChange="changePhone($event)"
                />
                <the-input
                    required
                    type="text"
                    name="store-email"
                    label="E-mail do sklepu"
                    :text="location.address.email"
                    :invalid="invalidEditModeValues.email"
                    :invalid-feedback="invalidFeedbackEmail"
                    :invalid-icon="false"
                    @input="changeEmail"
                />
            </div>
            <div class="typo--label">
                <span v-text="'*'" class="text-danger pl-1" />
                pola obowiązkowe
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        location: {
            type: Object,
            required: false
        },
        invalidEditModeValues: {
            type: Object
        },
        setInvalidEditModeValues: {
            type: Function,
            default: () => {}
        }
    },
    async created() {
        await this.changeName(this.location.full_name)
        await this.changeArea(this.location.address.area)
        await this.changePhone(this.location.address.phone)
        await this.changeEmail(this.location.address.email)
    },
    computed: {
        invalidFeedbackArea() {
            return this.location.address.area ? 'Wartość musi być większa od 0' : 'To pole nie może być puste'
        },
        invalidFeedbackPhone() {
            return !this.location.address.phone ? 'To pole nie może być puste' : 'Numer telefonu jest zbyt krótki'
        },
        invalidFeedbackEmail() {
            return this.location.address.email ? 'Niepoprawny adres e-mail' : 'To pole nie może być puste'
        }
    },
    methods: {
        changeName(event) {
            this.setInvalidEditModeValues({
                ...this.invalidEditModeValues,
                name: !event.length
            })
            this.location.full_name = event
        },
        changeArea(event) {
            this.setInvalidEditModeValues({
                ...this.invalidEditModeValues,
                area: !(event > 0)
            })
            this.location.address = {
                ...this.location.address,
                area: event
            }
        },
        changePhone(event) {
            const phoneValue = event?.replaceAll(/[-]/g, '').replace('+48 ', '')
            this.setInvalidEditModeValues({
                ...this.invalidEditModeValues,
                phone: phoneValue?.length !== 9
            })
            this.location.address.phone = phoneValue
        },
        changeEmail(event) {
            this.setInvalidEditModeValues({
                ...this.invalidEditModeValues,
                email: !event || !this.isEmailFormat(event)
            })
            this.location.address.email = event
        },
        isEmailFormat(value) {
            // eslint-disable-next-line
            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return regex.test(value)
        }
    }
}
</script>
